import { DestroyRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { TableColumn } from '../../../../@vex/interfaces/table-column.interface';
import { RealEstate } from '@eadsysteme/ewsrealestateclient-v2';
import { RealEstateTableEntity } from '../models/real-estate-table.model';
import { Observable } from 'rxjs';

export interface RealEstateViewStrategy {
	readonly viewType: ViewType;
	readonly menuName: string;

	getColumns(baseColumns: TableColumn<RealEstate>[], translate: (key: string) => string): TableColumn<RealEstate>[];

	enrichRowData(dataSource: MatTableDataSource<RealEstateTableEntity>, destroyRef: DestroyRef): void;

	onRowClick(row: RealEstateTableEntity, router: Router): void;

	onInit?(): void;

	/**
	 * Enriches a single RealEstateTableEntity with strategy-specific data.
	 * Used for pinned real estates that need additional data before navigation.
	 * Returns an Observable that completes when enrichment is done.
	 */
	enrichSingleEntity?(entity: RealEstateTableEntity): Observable<RealEstateTableEntity>;

	/**
	 * Handles navigation for a pinned real estate.
	 * Allows strategies to customize pinned navigation behavior.
	 * Returns true if the strategy handled the navigation, false otherwise.
	 */
	handlePinnedNavigation?(entity: RealEstateTableEntity, router: Router): void;
}

export enum ViewType {
	MAIN = 'main',
	BILLING = 'billing',
}

const VIEW_TYPE_BASE_PATHS: Record<ViewType, string> = {
	[ViewType.MAIN]: '/',
	[ViewType.BILLING]: '/billing-units/',
};

export function determineViewType(url: string): ViewType {
	if (url.includes('/billing-units')) {
		return ViewType.BILLING;
	}
	return ViewType.MAIN;
}

export function getBasePathForViewType(viewType: ViewType): string {
	return VIEW_TYPE_BASE_PATHS[viewType];
}
